import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bpManageForecastTreeData: [],
  bpManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  bpManageForecastFinalTreeData: [],
};

const BPManageScreenRedux = createSlice({
  name: "BPManageScreenRedux",
  initialState,
  reducers: {
    setBPManageForecastTreeData: (state, action) => {
      state.bpManageForecastTreeData = action.payload;
    },
    setBPManageForecastBottlerData: (state, action) => {
      state.bpManageForecastBottlerData = action.payload;
    },
    setBPManageForecastFinalTreeData: (state, action) => {
      state.bpManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setBPManageForecastTreeData,
  setBPManageForecastBottlerData,
  setBPManageForecastFinalTreeData,
} = BPManageScreenRedux.actions;
export default BPManageScreenRedux.reducer;
